module.exports = __webpack_public_path__ + "img/icon_construction.2492e49.svg";